export enum ExpiryFilterType
{
    All = 'All',
    ChartDueNowOrSoon = 'ChartDueNowOrSoon',
    CourseDueNowOrSoon = 'CourseDueNowOrSoon'
}

export enum CourseExpiryFilterSubType {
    CourseExpiryInOneDay = "CourseExpiryInOneDay",
    CourseExpiryInTwoDays = "CourseExpiryInTwoDays",
    CourseExpiryInThreeDays = "CourseExpiryInThreeDays",
    CourseExpiryInSevenDays = "CourseExpiryInSevenDays"
}